import React from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import CustomerService from "../../../images/FreeAppraisal/customer-service.svg";
import OfficeBuilding from "../../../images/FreeAppraisal/office-building.svg";
import { IoStar } from "react-icons/io5";
import FormComponent from "../Form/Form";
import secondaryFont from "@/utils/secondaryFont";

const BridgeLoansForm = ({ whiteBg = false, data, page = "" }) => {
  return (
    <section
      className={`section-center ${s.free_appraisal} ${
        whiteBg ? "" : s.grey_bg
      }`}
    >
      <Container>
        <h2 className="heading text-center fw-bold">
          {/* {data?.title || "Sell Your Luxury Item Or Apply For Collateral Loan"} */}
          {data?.free_appraisal_title || "Discuss Your Bridge Loan"}
        </h2>
        <div className={s.appraisal_wrapper}>
          <article className={s.map_container}>
            <div className={s.map}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12088.883081749484!2d-73.9786699!3d40.7571688!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c258fe5bfb8f53%3A0x84bc2a9bebac3f46!2sManhattan%20Buyers%20Inc.%20Rolex%20Buyer%2C%20Diamond%20Buyer%2C%20Gold%20Buyer%2C%20Sell%20Watch!5e0!3m2!1sen!2slk!4v1681709411340!5m2!1sen!2slk"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={"google-map-appraisal"}
              ></iframe>
            </div>
            <div className={`${s.map_details} d-none`}>
              <div className={s.location}>
                <div>
                  <img loading="lazy" src={OfficeBuilding.src} alt="image" />
                </div>
                <div>
                  <a href="">Visit Us At xxxxx to get an Instant Appraisal</a>
                  <p className={secondaryFont}>
                    590 5th Ave 10th Floor New York, NY 10036
                  </p>
                </div>
              </div>
              <div className={s.ratings}>
                <p className={secondaryFont}>Manhattan Buyers</p>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="me-3">
                    <IoStar size="16px" />
                    <IoStar size="16px" />
                    <IoStar size="16px" />
                    <IoStar size="16px" />
                    <IoStar size="16px" />
                  </div>
                  <p className="mb-0">168 reviews </p>
                </div>
              </div>
            </div>
          </article>
          <article className={s.forms}>
            <FormComponent buttonText="Get free offer" event="Bridge Loans" />
            <a
              href="tel:(212)913-9141"
              className={`${s.speak_with_expert} ${secondaryFont}`}
            >
              <div>
                <img
                  loading="lazy"
                  src={CustomerService.src}
                  alt="icon"
                  height="100%"
                />
              </div>
              <div>
                <p>
                  Speak with an
                  <span> expert</span>
                </p>
                <div>
                  <span>(212) 913-9141</span>
                </div>
              </div>
            </a>
          </article>
        </div>
      </Container>
    </section>
  );
};

export default BridgeLoansForm;
